import React from 'react';
import {ManuscriptModel} from "../../../models/manuscript.model";
import {Link} from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import styled from "styled-components";
import {Colors} from "../../../theme/colors";
import {CustomArrowRightIcon} from "../../ui-base/icons/custom-arrow-right-icon";
import {useTranslation} from "react-i18next";
import {SmallBookCover} from "../../shared/small-book-cover";

export const NewBookShort: React.FC<{ manuscript: ManuscriptModel, author?: string }> = ({manuscript, author}) => {
    const {t} = useTranslation(['author', 'common']);

    return (
        <StyledGridBookContainer className="book-short" item sm={12} md={6} lg={3}>
            <StyledContainer item container direction={'column'}>
                <StyledImageContainer item>
                    <SmallBookCover
                        title={manuscript?.title}
                        description={manuscript?.description}
                        author={author}
                    />
                </StyledImageContainer>
                <Grid item container direction={'column'}>
                    <Grid item>
                        <StyledDate>{t('bookShort.created')}: {new Date(manuscript.created).toLocaleString()}</StyledDate>
                    </Grid>

                    <Grid item style={{marginTop: '5px'}}>
                        <StyledDate>{t('bookShort.updated')}: {new Date(manuscript.updated).toLocaleString()}</StyledDate>
                    </Grid>

                    {/*<Grid item>*/}
                    {/*    <StyledStatus>Status utworu <span>Zgłoszony</span></StyledStatus>*/}
                    {/*</Grid>*/}

                    {/*<Grid item>*/}
                    {/*    <CustomLinearProgress*/}
                    {/*        value={90}*/}
                    {/*    />*/}
                    {/*</Grid>*/}

                    <Grid item>
                        <StyledPublisherInfo>{t('bookShort.sentToPub')}: <span>{manuscript.submitted_applications_count}</span></StyledPublisherInfo>
                    </Grid>

                    <Grid item>
                        <StyledProfileLink to={'/author/book/' + manuscript.id}>
                            {t('common:showDetails')}
                            <CustomArrowRightIcon style={{width: '12px', height: '10px', marginLeft: '5px'}}/>
                        </StyledProfileLink>
                    </Grid>
                </Grid>
            </StyledContainer>
        </StyledGridBookContainer>
    );
}

const StyledGridBookContainer = styled(Grid)`
  min-height: 422px;
`;

const StyledContainer = styled(Grid)`
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #E0E0E0;
  margin-top: 100px;
  padding: 0 20px 20px;
`;

const StyledImageContainer = styled(Grid)`
  margin-top: -80px;
  position: relative;
`;

const StyledDate = styled('p')`
  font-size: 0.9rem;
  color: ${Colors.grayText};
  font-weight: 400;
`;

// const StyledStatus = styled('p')`
//   font-size: 0.9rem;
//   font-weight: 500;
//   padding: 20px 0 15px;
//
//   span {
//     font-size: 0.8rem;
//     padding: 2px 5px;
//     border-radius: 10px;
//     border: 1px solid #B3DAC7;
//     background-color: #EBF5F0;
//     color: ${Colors.green};
//     margin-left: 5px;
//   }
// `;

const StyledPublisherInfo = styled('p')`
  font-size: 0.9rem;
  font-weight: 400;
  margin: 10px 0 30px;

  span {
    font-size: 1.1rem;
  }
`;

const StyledProfileLink = styled(Link)`
  color: ${Colors.lightViolet};
  font-weight: 500;
`;
